import { render } from "./resources.cattle.io.backup.vue?vue&type=template&id=d6706846"
import script from "./resources.cattle.io.backup.vue?vue&type=script&lang=js"
export * from "./resources.cattle.io.backup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__